import { useContext } from "react";
import { UserContext } from "../context/User.context";
export const whiteListeSuperAdmin = [
  "admin@oseo.ch",
  "fmorciano@oseo-vs.ch",
  "michael@thecomputerfirm.com",
];

export const isSuperAdmin = () => {
  const { user } = useContext(UserContext);

  if (whiteListeSuperAdmin.includes(user.email)) {
    return true;
  } else {
    return false;
  }
};
